module.exports = __webpack_public_path__ + "static/img/7.63201f03.png";